export default __webpack_public_path__ + "static/media/background_1.91449893.mp4";